// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperThumbnail-cls1_aaE","cls2":"PaperThumbnail-cls2_UuW PaperThumbnail-cls1_aaE"};